import { render, staticRenderFns } from "./OffersCds.vue?vue&type=template&id=082e4a80&"
import script from "./OffersCds.vue?vue&type=script&lang=js&"
export * from "./OffersCds.vue?vue&type=script&lang=js&"
import style0 from "./OffersCds.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37545539/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('082e4a80')) {
      api.createRecord('082e4a80', component.options)
    } else {
      api.reload('082e4a80', component.options)
    }
    module.hot.accept("./OffersCds.vue?vue&type=template&id=082e4a80&", function () {
      api.rerender('082e4a80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/acquisition/vitrine/offers/OffersCds.vue"
export default component.exports